// extracted by mini-css-extract-plugin
module.exports = {"wrapperClient":"OfferingTypeList-module__wrapperClient--VMZGg","wrapperAdvisor":"OfferingTypeList-module__wrapperAdvisor--2MHWK"};